export default __webpack_public_path__ + "static/media/profile_logo.a1fb35b4.jpg";